export default "__VITE_ASSET__DkfqSM7g__"